"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyConfirm = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var jyEduStages_1 = require("../../model/jyEduStages");
var service_1 = require("../../../library/base/service");
var ApplyConfirm = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ApplyConfirm, _super);
    function ApplyConfirm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '课程分期申请确认接口';
        _this.code = '101099';
        _this.desc = '课程分期申请确认接口';
        _this.requestParams = new jyEduStages_1.ApplyConfirmRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ApplyConfirm;
}(service_1.BaseService));
exports.ApplyConfirm = ApplyConfirm;
//# sourceMappingURL=applyConfirm.js.map